// pages/+Page.tsx
import { lazy, Suspense } from "react";
import LoadingComponent from "@fableous/ui/components/layout/LoadingComponent";
import OpenRoute from "@fableous/ui/components/routes/OpenRoute";
const HowItWorks = lazy(() => import("@fableous/ui/containers/marketing/HowItWorks"));

function Page() {
    return (
        <Suspense fallback={<LoadingComponent />}>
            <OpenRoute>
                <HowItWorks />
            </OpenRoute>
        </Suspense>
    );
}

export { Page };
